function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import Page from '@signal/layouts/Page';
import CommonHeader from '../CommonHeader/Component';
import MultiAppMenuPanel from '../MultiAppMenuPanel';
import UnauthorizedErrorBoundary from '../UnauthorizedErrorBoundary';

function createMultiAppMenuPanel(props) {
  return function () {
    return /*#__PURE__*/React.createElement(MultiAppMenuPanel, props);
  };
}

export function CommonPage(_ref) {
  var children = _ref.children,
      extraMenuItems = _ref.extraMenuItems,
      _ref$header = _ref.header,
      Header = _ref$header === void 0 ? CommonHeader : _ref$header,
      hideMenu = _ref.hideMenu,
      location = _ref.location,
      onAccountChange = _ref.onAccountChange,
      onLogout = _ref.onLogout,
      onNavigate = _ref.onNavigate,
      UserMenuNavLinks = _ref.UserMenuNavLinks,
      rest = _objectWithoutProperties(_ref, ["children", "extraMenuItems", "header", "hideMenu", "location", "onAccountChange", "onLogout", "onNavigate", "UserMenuNavLinks"]);

  var Left = createMultiAppMenuPanel({
    extraMenuItems: extraMenuItems,
    location: location,
    onNavigate: onNavigate
  });
  return /*#__PURE__*/React.createElement(Page, {
    constrainWidth: false,
    left: hideMenu ? undefined : Left
  }, /*#__PURE__*/React.createElement(Header, Object.assign({
    hideMultiAppMenu: true,
    hideLogo: true,
    location: location,
    onAccountChange: onAccountChange,
    onLogout: onLogout,
    onNavigate: onNavigate,
    UserMenuNavLinks: UserMenuNavLinks
  }, rest)), /*#__PURE__*/React.createElement(UnauthorizedErrorBoundary, null, children));
}
export default /*#__PURE__*/memo(CommonPage);